import { defineMessages } from 'react-intl';

const messages = defineMessages({
  isSupplierShipped: {
    id: 'UseItemAttributes.isSupplierShipped',
    defaultMessage: 'Supplier Shipped',
  },
  assets: {
    id: 'UseItemAttributes.assets',
    defaultMessage: 'Assets',
  },
  shopId: {
    id: 'UseItemAttributes.shopId',
    defaultMessage: 'Shop ID',
  },
  offerId: {
    id: 'UseItemAttributes.offerId',
    defaultMessage: 'Offer ID',
  },
  shopName: {
    id: 'UseItemAttributes.shopName',
    defaultMessage: 'Shop Name',
  },
  shopDescription: {
    id: 'UseItemAttributes.shopDescription',
    defaultMessage: 'Shop Description',
  },
  shopReturnPolicy: {
    id: 'UseItemAttributes.shopReturnPolicy',
    defaultMessage: 'Shop Return Policy',
  },
  minShopOrderValue: {
    id: 'UseItemAttributes.minShopOrderValue',
    defaultMessage: 'Minimum Shop Order Value',
  },
  minOrderQty: {
    id: 'UseItemAttributes.minOrderQty',
    defaultMessage: 'Minimum Order Quantity',
  },
  maxOrderQty: {
    id: 'UseItemAttributes.maxOrderQty',
    defaultMessage: 'Max Order Quantity',
  },
  grossWeight: {
    id: 'UseItemAttributes.grossWeight',
    defaultMessage: 'Gross Weight',
  },
  title: {
    id: 'UseItemAttributes.title',
    defaultMessage: 'Title',
  },
  id: {
    id: 'UseItemAttributes.id',
    defaultMessage: 'ID',
  },
  itemId: {
    id: 'UseItemAttributes.itemId',
    defaultMessage: 'Item ID',
  },
  hostSystem: {
    id: 'UseItemAttributes.hostSystem',
    defaultMessage: 'Host System',
  },
  itemNumber: {
    id: 'UseItemAttributes.itemNumber',
    defaultMessage: 'Item Number',
  },
  upc: {
    id: 'UseItemAttributes.upc',
    defaultMessage: 'UPC',
  },
  plu: {
    id: 'UseItemAttributes.plu',
    defaultMessage: 'PLU',
  },
  description: {
    id: 'UseItemAttributes.description',
    defaultMessage: 'Description',
  },
  extendedDescription: {
    id: 'UseItemAttributes.extendedDescription',
    defaultMessage: 'Extended Description',
  },
  countryOfOriginCode: {
    id: 'UseItemAttributes.countryOfOriginCode',
    defaultMessage: 'Country Of Origin Code',
  },
  countryOfOriginName: {
    id: 'UseItemAttributes.countryOfOriginName',
    defaultMessage: 'Country Of Origin Name',
  },
  ingredients: {
    id: 'UseItemAttributes.ingredients',
    defaultMessage: 'Ingredients',
  },
  organicCode: {
    id: 'UseItemAttributes.organicCode',
    defaultMessage: 'Organic Code',
  },
  brandId: {
    id: 'UseItemAttributes.brandId',
    defaultMessage: 'Brand ID',
  },
  brandName: {
    id: 'UseItemAttributes.brandName',
    defaultMessage: 'Brand Name',
  },
  departmentId: {
    id: 'UseItemAttributes.departmentId',
    defaultMessage: 'Department ID',
  },
  departmentName: {
    id: 'UseItemAttributes.departmentName',
    defaultMessage: 'Department Name',
  },
  categoryId: {
    id: 'UseItemAttributes.categoryId',
    defaultMessage: 'Category ID',
  },
  categoryName: {
    id: 'UseItemAttributes.categoryName',
    defaultMessage: 'Category Name',
  },
  subcategoryId: {
    id: 'UseItemAttributes.subcategoryId',
    defaultMessage: 'Subcategory ID',
  },
  subcategoryName: {
    id: 'UseItemAttributes.subcategoryName',
    defaultMessage: 'Subcategory Name',
  },
  statusCode: {
    id: 'UseItemAttributes.statusCode',
    defaultMessage: 'Status Code',
  },
  itemAttributes: {
    id: 'UseItemAttributes.itemAttributes',
    defaultMessage: 'Item Attributes',
  },
  availableAtDcNumbers: {
    id: 'UseItemAttributes.availableAtDcNumbers',
    defaultMessage: 'Available At DC Numbers',
  },
  dcName: {
    id: 'UseItemAttributes.dcName',
    defaultMessage: 'DC Name',
  },
  dcNumber: {
    id: 'UseItemAttributes.dcNumber',
    defaultMessage: 'DC Number',
  },
  promoAtDcNumbers: {
    id: 'UseItemAttributes.promoAtDcNumbers',
    defaultMessage: 'Promo At DC Numbers',
  },
  organicCodePercentage: {
    id: 'UseItemAttributes.organicCodePercentage',
    defaultMessage: 'Organic Code Percentage',
  },
  packConfigCode: {
    id: 'UseItemAttributes.packConfigCode',
    defaultMessage: 'Pack Config',
  },
  packQty: {
    id: 'UseItemAttributes.packQty',
    defaultMessage: 'Pack Quantity',
  },
  packSize: {
    id: 'UseItemAttributes.packSize',
    defaultMessage: 'Pack/Size',
  },
  corpItemCode: {
    id: 'UseItemAttributes.corpItemCode',
    defaultMessage: 'Corporate Item Code',
  },
  isVariableWeight: {
    id: 'UseItemAttributes.isVariableWeight',
    defaultMessage: 'Is Variable Weight',
  },
  isPrivateLabel: {
    id: 'UseItemAttributes.isPrivateLabel',
    defaultMessage: 'Is Private Label',
  },
  sugarTaxZipcodes: {
    id: 'UseItemAttributes.sugarTaxZipcodes',
    defaultMessage: 'Sugar Tax Zipcodes',
  },
  bottleDepositStates: {
    id: 'UseItemAttributes.bottleDepositStates',
    defaultMessage: 'Bottle Deposit States',
  },
  isLongLeadItem: {
    id: 'UseItemAttributes.isLongLeadItem',
    defaultMessage: 'Is Long Lead Item',
  },
  leadTimeDays: {
    id: 'UseItemAttributes.leadTimeDays',
    defaultMessage: 'Lead Time Days',
  },
  elasticId: {
    id: 'UseItemAttributes.elasticId',
    defaultMessage: 'Elastic ID',
  },
  itemAtOtherDcs: {
    id: 'UseItemAttributes.itemAtOtherDcs',
    defaultMessage: 'Item at Other Dcs',
  },
  additionalDetails: {
    id: 'UseItemAttributes.additionalDetails',
    defaultMessage: 'Additional Details',
  },
});

export default messages;
